import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext } from 'react';
import PunchCursor from 'images/place-punch-cursor.png';
import { useTranslator } from '@bluebeam/react-i18n';

const PlacePunchMessageOverlay: FC = (props) => {
  const { actions } = useContext(AppStoreContext);
  const handlePlacePunchCancelClick = async (): Promise<void> => {
    actions.deleteInteractions('PlacePunch');
  };
  const { translate } = useTranslator(['mapView', 'buttons']);

  return (
    <>
      <style>
        {`
          #sheet-viewer-container {
            cursor:url(${PunchCursor}) 10 10, auto !important;
          }
        `}
      </style>
      <div
        className="pos-a flex-center"
        style={{ zIndex: 3, top: '128px', left: 'calc(50vw - 157.5px)' }}
      >
        <div
          className="bgd-black-1-opacity-80 white-1 px4 py3 flex-center b-radius-3"
          style={{ width: '315px' }}
        >
          {translate('mapView:placePunchMessage.placePunchMarkupOnDrawing')}
        </div>
      </div>
      <div
        className="pos-a hrem-4p5 w100 bgd-white-2 flex justify-end items-center px4"
        style={{ bottom: '-48px' }}
      >
        <button className="btn btn-link" onClick={handlePlacePunchCancelClick}>
          {translate('buttons:cancel')}
        </button>
      </div>
    </>
  );
};

export default PlacePunchMessageOverlay;
